module.exports = __webpack_public_path__ + "static/img/宣传片-Case Video.a47b771.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10005/宣传片-Case Video.png
// module id = YaBk
// module chunks = 1